<script setup lang="ts">
import type { Radio } from '#imports';

interface IProps {
    items?: Radio<number>[];
    loading?: boolean;
    hasSelectAll?: boolean;
    label?: string;
    description?: string;
    itemsTitle?: string;
    allTitle?: string;
    selectAllInitially?: boolean;
}

const {
    label = '',
    allTitle = '',
    itemsTitle = '',
    description = '',
    items = [],
    loading,
    hasSelectAll,
    selectAllInitially,
} = defineProps<IProps>();

const emit = defineEmits<{
    removeAll: [];
    remove: [items: number[]];
    close: [];
}>();

const selectedItems = ref<number[]>([]);

const isFullyRemoving = computed(
    () => items.length === selectedItems.value.length
);

const isPartiallyRemoving = computed(
    () => !isFullyRemoving.value && !!items.length
);

const disabled = computed(() => selectedItems.value.length === 0);

function toggle(id: number) {
    if (selectedItems.value.includes(id)) {
        selectedItems.value = selectedItems.value.filter(item => item !== id);
    } else {
        selectedItems.value = [...selectedItems.value, id];
    }
}

function selectAll() {
    if (isFullyRemoving.value) {
        selectedItems.value = [];
    } else {
        selectedItems.value = items.map(item => item.value);
    }
}

function submit() {
    if (isFullyRemoving.value) {
        emit('removeAll');
    } else {
        emit('remove', selectedItems.value);
    }
}

function close() {
    emit('close');
    selectedItems.value = [];
}

onMounted(() => {
    if (selectAllInitially) {
        selectAll();
    }
});
</script>

<template>
    <mr-modal width="fit-content" :title="label" @close="close">
        <div class="cancel-content">
            <mr-input-container
                size="free"
                full-width
                :label="description"
                ghost
            >
                <div class="checkbox-container">
                    <mr-checkbox
                        v-if="hasSelectAll"
                        :model-value="isFullyRemoving"
                        label="انتخاب همه"
                        :intermediate="isPartiallyRemoving"
                        @update:model-value="selectAll"
                    />
                    <mr-checkbox
                        v-for="item in items"
                        :key="item.value"
                        :model-value="selectedItems.includes(item.value || 0)"
                        :label="item.label"
                        @update:model-value="toggle(item.value || 0)"
                    />
                </div>
            </mr-input-container>
        </div>
        <template #footer>
            <div class="actions">
                <mr-button variant="bordered" full-width @click="close">
                    بستن
                </mr-button>
                <mr-button :disabled full-width :loading @click="submit">
                    حذف {{ isFullyRemoving ? allTitle : itemsTitle }}
                </mr-button>
            </div>
        </template>
    </mr-modal>
</template>

<style scoped lang="scss">
.cancel-content {
    padding: 8px;
}
.actions {
    display: flex;
    align-items: center;
    gap: 8px;
}
.checkbox-container {
    display: flex;
    flex-direction: column;
    gap: 12px;
}
</style>
